import { ChevronDownIcon } from 'lucide-react'

import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from '@/components/dialog/dialog'

import { EXTERNAL_URLS } from '@/lib/constants/url'
import { cn } from '@/lib/utils'

export interface HistoryUsageGuideDialogProps {
  open: boolean
  closeDialog: VoidFunction
}

export const HistoryUsageGuideDialog = ({ open, closeDialog }: HistoryUsageGuideDialogProps) => {
  return (
    <Dialog
      open={open}
      onOpenChange={(open) => {
        if (!open) {
          closeDialog()
        }
      }}
    >
      <DialogContent>
        <DialogHeader className="mb-3">
          <DialogTitle>There are two types of messages for USCIS case</DialogTitle>
          <DialogDescription className="sr-only">
            The contents of this modal indicates how to read the 2 types of history message in the history list.
          </DialogDescription>
        </DialogHeader>

        <div className={cn('text-[14px] font-normal leading-[24px]')}>
          To help you better understand your case progress, we provide two types of historical updates, sourced from
          Case Status Online (
          <a
            href={EXTERNAL_URLS.caseStatusOnline}
            target="_blank"
            rel="noreferrer"
            className={cn('text-blue-600 underline')}
          >
            egov.uscis.gov
          </a>
          ) and myUSCIS (
          <a href={EXTERNAL_URLS.myUscis} target="_blank" rel="noreferrer" className={cn('text-blue-600 underline')}>
            my.uscis.gov
          </a>
          ). These messages might look similar, especially if they occur on the same date, but they serve complementary
          purposes.
        </div>

        <div>
          <p className={cn('text-base font-medium', 'mb-3.5')}>USCIS Case status message</p>
          <div className={cn('rounded-[8px]', 'bg-secondary', 'px-5 py-4')}>
            <p className={cn('flex items-center justify-between', 'text-[14px] leading-[18px]')}>
              <span>Biometrics Appointment Was Scheduled</span>
              <ChevronDownIcon size={24} />
            </p>
            <p className={cn('mt-5', 'text-[13px] font-normal leading-[18px] text-[#555]')}>
              As of June 24, 2018, we are processing the fingerprints for your Form I-765, Application for Employment
              Authorization, Receipt Number MSC1890104381, at our National Benefits Center location. We will send any
              case updates or notices to the address you gave us. If you move, go to www.uscis.gov/addresschange to give
              us your new mailing address.
            </p>
          </div>
        </div>

        <div className={cn('mt-2')}>
          <p className={cn('text-base font-medium')}>myUSCIS message</p>
          <div className={cn('rounded-[8px]', 'bg-sky-100', 'px-5 py-4', 'mt-3.5')}>
            <p className={cn('text-[14px] font-medium leading-[18px]')}>
              We scheduled you for a biometrics appointment
            </p>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  )
}
